import { useTranslation } from 'react-i18next'
import { Save, Undo } from '@mui/icons-material'
import { Button, CircularProgress } from '@mui/material'
import PropTypes from 'prop-types'

import TbxToolbar from '@/common/components/TbxToolbar/TbxToolbar'
import TbxToolbarActions from '@/common/components/TbxToolbar/TbxToolbarActions'
import TbxToolbarDivider from '@/common/components/TbxToolbar/TbxToolbarDivider'
import TbxToolbarTitle from '@/common/components/TbxToolbar/TbxToolbarTitle'

import TbxToolbarMessages from '../../TbxToolbar/TbxToolbarMessages'

const OrganisationManagementToolbar = ({
    handleCancelClick,
    handleUpdateClick,
    isCancelButtonDisabled = false,
    isLoading,
    isUpdateButtonDisabled = false,
    title = 'Organisation management',
}) => {
    const { t } = useTranslation()

    return (
        <TbxToolbar>
            <TbxToolbarTitle>{t(title)}</TbxToolbarTitle>

            <TbxToolbarMessages />

            <TbxToolbarActions>
                <Button
                    color="secondary"
                    data-testid="reset-settings"
                    disabled={isCancelButtonDisabled || isLoading}
                    startIcon={<Undo />}
                    variant="outlined"
                    onClick={handleCancelClick}
                >
                    {t('Cancel')}
                </Button>
                <TbxToolbarDivider />
                <Button
                    color="primary"
                    data-testid="create-quote"
                    disabled={isUpdateButtonDisabled || isLoading}
                    startIcon={
                        isLoading ? (
                            <CircularProgress
                                color="primary"
                                size={20}
                            />
                        ) : (
                            <Save />
                        )
                    }
                    variant="contained"
                    onClick={handleUpdateClick}
                >
                    {t(isLoading ? 'Updating' : 'Update')}
                </Button>
            </TbxToolbarActions>
        </TbxToolbar>
    )
}

OrganisationManagementToolbar.propTypes = {
    handleCancelClick: PropTypes.func,
    handleUpdateClick: PropTypes.func,
    isCancelButtonDisabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    isUpdateButtonDisabled: PropTypes.bool,
    title: PropTypes.string,
}

export default OrganisationManagementToolbar
